import { render } from "./Patents.vue?vue&type=template&id=66ababbc"
import script from "./Patents.vue?vue&type=script&lang=js"
export * from "./Patents.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Samson5\\Scripts\\CVue-Awesome\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__